export const cardStyle = {
    marginLeft: '20px',
    marginRight: '20px',
    marginTop: '20px',
    marginBottom: '20px',
    padding: '20px',
    background: 'white',
    border: '1px solid rgba(0,0,0,0.0625)'
};

export const lineColors = [
    '#6A92C4',
    '#1F7037',
    '#E8CE2C',
    '#B73C5D'
];


/**
 * merges two style objects together
 * @param {object} style base style
 * @param {object} additionalStyles style to lay over style
 * @returns {object} a new object with style merged with additional style
 * taking additionalStyles at a high priority
 */
export function mergeStyle(style, additionalStyles) {
    let newStyle = {};
    for (let styleKey in style)  {
        newStyle[styleKey] = style[styleKey];
    }
    for (let key in additionalStyles) {
        newStyle[key] = additionalStyles[key];
    }

    return newStyle;
}


export const colorDictionary = {
    green: '#2aa300',
    yellow: '#ffe500',
    orange: '#ff8c00',
    red: '#c60f0f',
};

export const greens = [
     "#edf8e9",
    "#bae4b3",
    "#74c476",
    "#238b45"
];

export const blues = [
    "#deebf7",
    "#9ecae1",
    "#3182bd"
];

export function getColor(colors, index, opacity) {
    return colors[index] + opacity;
}

export function getGreen(color, opacity) {
    return greens[color] + opacity;
};

export function getTransparentColor(color, opacity) {
    return colorDictionary[color] + opacity;
}



// WEBPACK FOOTER //
// ./src/components/styles.js